import React, { useEffect, useState, useTransition } from "react";
import { Modal, Divider, Form, DatePicker, Input, Select, Button } from "antd";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import FileUpload from "../commons/fileUpload";
import config from "../../config";
import moment from "moment";
import dayjs from "dayjs";
import TextArea from "antd/es/input/TextArea";

const useStyles = makeStyles((theme) => ({
  dividerStyle: {
    marginTop: 14,
    marginBottom: 14,
    border: "0.5px solid #909090",
  },
  modalStyle: {
    "& .ant-modal-content": {
      borderRadius: "2rem",
    },
  },
  ButtonStyle: {
    backgroundColor: "#EF4667",
    color: "#fff",
    border: 0,
    borderRadius: "4px",
    paddingLeft: "34px",
    paddingRight: "34px",
    "&:hover": {
      backgroundColor: "#EF4667",
      color: "#fff",
    },
  },
  selectStyle: {
    "& legend": {
      display: "none",
    },
  },
  inputStyle: {
    "& label": {
      display: "none",
    },
  },
  formInput: {
    borderRadius: 8,
  },
  formItem: {
    "& .ant-col ant-col-24 ant-form-item-label": {
      padding: 0,
    },
  },
  selectInput: {
    "&.ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector":
      {
        borderRadius: "0 8px 8px 0",
      },
  },
  unitFormItem: {
    borderRadius: "8px 0 0 8px",
  },
  taxTypeInput: {
    "&.ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector":
      {
        borderRadius: 8,
      },
  },
}));
const ExpensesModal = ({
  open,
  setOpen,
  fetchExpenses,
  initialValues = {},
  mode = "add",
  counterId = "",
  dateField = true,
}) => {
  const classes = useStyles();
  const [form] = Form.useForm();

  const [isPending, stateTransition] = useTransition();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    setLoading(true);
    stateTransition(async () => {
      const payload = {
        ...values,
        expenseDate: values.expenseDate
          ? dayjs(values.expenseDate).format("YYYY-MM-DD")
          : moment().format("YYYY-MM-DD"),
        shopId: shopDetails.shopId,
        notes: values.notes || "",
        counterId: counterId ? counterId : "",
        employeeId: shopDetails.empId ? shopDetails.empId : "",
        ...(["Employee", "Outlet"].includes(shopDetails.userType) && {
          parentShopId: shopDetails.ownerShopId,
        }),
      };

      try {
        let res = await fetch(`${config.newApiGateway}/expenses/expenses`, {
          method: "POST",
          headers: {
            "x-api-key": `${config.newApiKey}`,
            "Content-type": "application/json",
          },
          body: JSON.stringify({
            type: mode === "edit" ? "edit" : "add",
            ...(mode === "edit" && {
              billId: initialValues.billId,
            }),
            shopId: shopDetails.shopId,
            ...payload,
          }),
        });
        res = await res.json();
        console.log("ExpensesRes", res);
        if (res.code === "ERROR") {
          return alert(res.message);
        }
        if (res.code === "SUCCESS") {
          fetchExpenses(counterId);
        }
      } catch (err) {
        console.error("Error", err);
      } finally {
        setOpen(false);
        setLoading(false);
        form.resetFields();
      }
    });
  };
  const normFile = (e) => {
    console.log("Upload event:", e);
    if (Array.isArray(e)) {
      return e;
    }
    return e;
  };
  const handleClose = () => {
    setOpen(false);
  };
  const shopDetails = useSelector((state) => state.shopDetails);

  useEffect(() => {
    if (mode === "edit") {
      form.setFieldsValue({
        ...initialValues,
        expenseType: initialValues.expenseType,
        expenseAmount: initialValues.expenseAmount,
        expenseDate: moment(initialValues.expenseDate, "YYYY-MM-DD"),
      });
    } else {
      form.resetFields();
    }
  }, [initialValues, mode, form]);

  return (
    <Modal
      open={open}
      footer={false}
      centered
      className={classes.modalStyle}
      width={700}
      onCancel={handleClose}
    >
      <h4
        style={{
          color: "#000000",
        }}
      >
        {mode === "edit" ? "Edit" : "Add"} Expenses
      </h4>
      <Divider className={classes.dividerStyle} />
      <Form
        onFinish={handleSubmit}
        form={form}
        // initialValues={
        //   mode === "edit"
        //     ? {
        //         expenseType: initialValues.expenseType,
        //         expenseAmount: initialValues.expenseAmount,
        //         expenseDate: moment(initialValues.expenseDate, "YYYY-MM-DD"),
        //       }
        //     : {}
        // }
      >
        {dateField && (
          <Form.Item
            name={"expenseDate"}
            className={classes.formItem}
            rules={[
              {
                required: true,
                message: "Please enter a Expense date",
              },
            ]}
          >
            <DatePicker
              format={"DD-MM-YYYY"}
              style={{
                width: "100%",
              }}
              size="large"
              placeholder="Enter Date"
            />
          </Form.Item>
        )}
        <Form.Item
          name={"expenseAmount"}
          className={classes.formItem}
          rules={[
            {
              required: true,
              message: "Please enter a Expense amount",
            },
          ]}
        >
          <Input
            type="number"
            size="large"
            style={{
              width: "100%",
            }}
            placeholder="Enter Expense Amount"
          />
        </Form.Item>
        <Form.Item
          name={"expenseType"}
          className={classes.formItem}
          rules={[
            {
              required: true,
              message: "Please enter a type",
            },
          ]}
        >
          <Select size="large" placeholder="Select Expense Type">
            {shopDetails.expensesType
              .filter((i) => !i.deleted)
              .map((type) => {
                return (
                  <Select.Option
                    key={type.expensesTypeId}
                    value={type.expensesTypeId}
                  >
                    {type.expensesTypeName}
                  </Select.Option>
                );
              })}
          </Select>
        </Form.Item>
        <Form.Item
          name={"paymentMethod"}
          className={classes.formItem}
          rules={[
            {
              required: true,
              message: "Please enter a paymentMethod",
            },
          ]}
        >
          <Select size="large" placeholder="Select Payment Method">
            <Select.Option value="cash">Cash</Select.Option>
            {dateField && (
              <>
                <Select.Option value="card">Card</Select.Option>
                <Select.Option value="upi">UPI</Select.Option>
              </>
            )}
          </Select>
        </Form.Item>
        <Form.Item name={"notes"} className={classes.formItem}>
          <TextArea placeholder="Enter Notes..." />
        </Form.Item>
        <Form.Item name={"images"} getValueFromEvent={normFile}>
          <FileUpload />
        </Form.Item>
        <Divider className={classes.dividerStyle} />
        <div
          style={{
            textAlign: "right",
          }}
        >
          <Button
            style={{
              background: "#FFF",
              color: "#EF4667",
            }}
            onClick={handleClose}
            size="large"
          >
            Cancel
          </Button>
          <Button
            style={{
              background: "#EF4667",
              color: "#fff",
              marginLeft: "1rem",
            }}
            loading={loading}
            disabled={loading}
            size="large"
            htmlType="submit"
          >
            Submit
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default ExpensesModal;
